module.exports = __webpack_public_path__ + "img/MultipleUsers.de0417d7.svg";